<!-- Content -->
<div class="flex flex-1 flex-column row-gap-3 overflow-auto justify-content-center">
  <!-- Form -->
  @if (linkForm) {
    <input type="text" class="w-full p-inputtext" [placeholder]="'global.search_query_or_link' | translate" [(ngModel)]="searchString" (input)="debouncedSearch()">

    @if (linkType() !== 'external') {
      <div class="h-18rem overflow-auto px-1">
        @if (this.pendingSearch()) {
          <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
        } @else {
          @if (this.searchControlFacade.nodeSearchResult$ | async; as searchResults) {
            @if (searchResults.total > 0) {
              @for(result of searchResults.items; track result.id) {
                <button class="w-full my-1" medsurf-design-input-button (click)="onSelect(result)" 
                  [inputClass]="('/node/' + result.id) === linkForm.value.href ? FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY : FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY">
                  <span class="text-left">
                    <strong>{{result.title}}</strong><br>
                    {{result.path}}
                  </span>
                </button>
              }
            } @else {
              <div class="w-full my-1">
                {{ 'primeng.emptySearchMessage' | translate }}
              </div>
            }
          }
        }
      </div>
    }

    <medsurf-design-form-control-form
      [formGroup]="linkForm"
      class="w-full relative">
      <!-- Target -->
      <medsurf-design-form-control-input-switch
          [control]="linkForm.controls.targetBlank"
          label="global.open_in_new_tab"></medsurf-design-form-control-input-switch>
    </medsurf-design-form-control-form>
    <!-- Save changes -->
    <div class="flex">
      <button medsurf-design-input-button id="save_changes"
              [disabled]="linkForm.invalid"
              [label]="'global.save_changes' | translate"
              (click)="onModalSubmit()"></button>
    </div>
  }
</div>
